import { initializeServiceMocker } from './service-mocker'

const initializeApp = () => initializeServiceMocker()

export default initializeApp
